import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import AaChainVis from 'antibodies/nested-data-creation/antibody-component-visualization/AaChainVis';
import AaDomainVis from 'antibodies/nested-data-creation/antibody-component-visualization/AaDomainVis';
import DnaDomainVis from 'antibodies/nested-data-creation/antibody-component-visualization/DnaDomainVis';

export enum AntibodyComponentType {
  AA_DOMAIN = 'AA_DOMAIN',
  DNA_DOMAIN = 'DNA_DOMAIN',
  AA_CHAIN = 'AA_CHAIN',
}

const ANTIBODY_COMPONENT_SVG_PADDING = 4;

const COMPONENT_TYPE_TO_RENDERED_SVG: {[componentType in AntibodyComponentType]: () => JSX.Element} = {
  [AntibodyComponentType.AA_DOMAIN]: AaDomainVis,
  [AntibodyComponentType.DNA_DOMAIN]: DnaDomainVis,
  [AntibodyComponentType.AA_CHAIN]: AaChainVis,
};

interface AntibodyComponentSvgProps {
  componentType: AntibodyComponentType;
  size: number;
}

/**
 * Renders an SVG representing a component of an antibody on a gray background.
 */
export default function AntibodyComponentSvg({componentType, size}: AntibodyComponentSvgProps): JSX.Element {
  return (
    <div className={css(styles.container)} style={{width: `${size}px`, height: `${size}px`}}>
      <svg
        className={css(styles.componentSvg)}
        height={size - ANTIBODY_COMPONENT_SVG_PADDING * 2}
        width={size - ANTIBODY_COMPONENT_SVG_PADDING * 2}
        // All component visualizations are expected to be exported in a 72x62 viewbox.
        viewBox="0 0 72 62"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        {COMPONENT_TYPE_TO_RENDERED_SVG[componentType]()}
      </svg>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    backgroundColor: Color.GRAY_50,
    borderRadius: 4,
    border: `1px solid ${Color.GRAY_100}`,
  },
  componentSvg: {
    margin: 'auto',
  },
});
